export const removeTrailingSlash = (url: string) =>
  url.endsWith('/') ? url.slice(0, url.length - 1) : url
